import React from 'react';

import { PasswordConstraints } from '../components/password-constraints/password-constraints';
import { PasswordValidator } from '../utils/password-validator';

type Props = {
  password: string;
};

const usePasswordConstraints = (props: Props) => {
  const minDigits = 1;
  const minLength = 10;
  const minLowerCase = 1;
  const minUpperCase = 1;

  return {
    minDigits: minDigits,
    minLength: minLength,
    minLowerCase: minLowerCase,
    minUpperCase: minUpperCase,
    render: () => (
      <PasswordConstraints
        minDigits={minDigits}
        minLength={minLength}
        minLowerCase={minLowerCase}
        minUpperCase={minUpperCase}
        password={props.password}
      />
    ),
    isValid: new PasswordValidator(minLength, minUpperCase, minLowerCase, minDigits).isValid(
      props.password,
    ),
  };
};

export { usePasswordConstraints };
